export default {
  dp: {
    footer: {
      cookieSettings: 'Configuración de cookies',
    },
    petPanel: {
      knowBreed: "¿Conoces la raza de tu mascota?",
      whatBreed: "¿Qué raza es?",
      breedInfoPanel: "Empieza ingresando la raza de tu mascota. Luego, selecciona entre las opciones mostradas. Escoge la opción que más se acerque a la raza de tu mascota. Seleccionar una raza ayuda a otros a identificar a tu mascota si esta se reporta como perdida.",
      breedEditLink: "editar",
    },
    navbar: {
      language: 'Idioma',
      locales: {
        en_CA: 'English [CA]',
        en_US: 'English [US]',
        es_US: 'Español [US]',
        fr_CA: 'Français [CA]',
      },
    },
    input: {
      dates: {
        errors: {
          mustBeEighteenOptional: 'Compartir tu fecha de nacimiento es opcional, Sin embargo, debes tener 18 años o más para que puedas obtener una licencia'
        },
      },
      breed: {
        customErrorMessage: {
          breedAllowedChars: 'Las razas de mascotas solo pueden contener letras, espacios, (paréntesis), y el símbolo “+”.',
          required: "Por favor, ingresa la raza de la mascota",
        }
      },
      breedKnown: {
        customErrorMessage: {
          required: 'Por favor, realiza una selección entre lo que se muestra arriba',
        }
      }
    }
  },
};
